import { Component, Prop } from 'vue-property-decorator';
import gameChildComponents from '@/components/game/implementations/_default/_components';
import { IBingo75GameRepresentation } from '@/components/game/implementations/uk/bingo-75/_domain/controller/game-controller';
import TombolaBaseComponent from '@/components/base/base.component';
import { User } from '@/app-modules/store/modules/user';
import { GameState, IGameStateChangedArgs, IGameRepresentationChangedArgs, IGameConnectionStateChangedArgs } from '@/components/game/_domain/models';
import { IGameServerService } from '@/app-modules/server-service';
import { IRetryPolicySettings } from '@/app-modules/server-communications';
import { IGameController } from '@/components/game/_domain/models/game-controller';

@Component({
  name: 'Bingo75GameViewComponent',
  components: gameChildComponents
})
export default class Bingo75GameViewComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  private gameRepresentation: IBingo75GameRepresentation = null;
  private gameState: GameState = GameState.InPlay;
  private gameConnectionState: string = '';

  private mounted() {
    const currentUser = this.$tombolaStore.Get(User);
    this.gameController
        .onGameStateChanged(this.handleGameStateChanged)
        .onGameRepresentationChanged(this.handleGameRepresentationChanged)
        .onGameConnectionStateChanged(this.handleGameConnectionStateChanged)
        .connectToGameServer(currentUser);
  }

  private get gameId(): number {
    return this.gameRepresentation ? this.gameRepresentation.gameId : null;
  }

  private get gameNumberOfPlayers(): number {
    return this.gameRepresentation ? this.gameRepresentation.numberOfPlayers : 0;
  }

  private get isCurrentGameALinkedGame(): boolean {
    return this.gameRepresentation ? this.gameRepresentation.isLinkedGame : false;
  }

  private get server(): IGameServerService {
    return this.gameController ? this.gameController.getServerService() : null;
  }

  private get retryPolicySettings(): IRetryPolicySettings {
    return this.gameController ? this.gameController.getRetryPolicySettings() : null;
  }

  private handleGameStateChanged(eventArgs: IGameStateChangedArgs) {
    this.gameState = eventArgs.currentGameState;
  }

  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    this.gameRepresentation = eventArgs.currentGameRepresentation;
  }

  private handleGameConnectionStateChanged(eventArgs: IGameConnectionStateChangedArgs) {
    this.gameConnectionState = eventArgs.currentConnectionState;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/bingo-75/game-view/game-view.component.ts